import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import LangSwitcher from '../LangSwitcher';
import HeaderBar from '../HeaderBar';
import MenuButtons from '../MenuButtons';

const HeaderTop = props => {
  const { enableTSSSO = false, className = '' } = props;
  return (
    <div className={`${className} header__top`}>
      <Container>
        <Row>
          <Col>
            <MenuButtons type="HeaderTop" className="hideNonTablet" />
            <HeaderBar type="HeaderTop" enableTSSSO={enableTSSSO} />
            <LangSwitcher />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default HeaderTop;
